import { registerFigure } from "./base.js";
/**
 * Steps in order, running left to right and stopping at the end.
 *
 * The biggest gap the first three kinds left. An enormous share of science is
 * "and then this happens" — how rain forms, how food is digested, how a sound
 * reaches your ear, how a seed becomes a plant — and none of the others fit:
 * `cycle` claims the last step leads back to the first, which is a factual
 * assertion and usually false, and `parts` claims the steps are stacked inside
 * one another, which they aren't.
 *
 * The arrow that does NOT come back round is the whole content.
 */
export const sequenceFigure = registerFigure({
    kind: "sequence",
    summary: "Steps in order, left to right, ending where they end.",
    chooseWhen: "Something happens in a fixed order and then it is over — how rain forms, " +
        "how food is digested, how a sound reaches your ear, what happens when you " +
        "catch a cold. Use this and not a cycle unless the last step genuinely " +
        "starts the first one again.",
    issues(figure) {
        const labels = figure.labels ?? [];
        if (labels.length < 2)
            return ["A sequence needs at least two steps."];
        if (labels.length > 5)
            return ["More than 5 steps stops being a picture."];
        if (labels.some((l) => l.trim().length === 0))
            return ["A step cannot be blank."];
        return [];
    },
    normalise(figure) {
        return {
            kind: "sequence",
            caption: figure.caption,
            labels: (figure.labels ?? []).map((l) => l.trim()),
        };
    },
    example: {
        kind: "sequence",
        caption: "Each step has to finish before the next can start.",
        labels: ["Sun warms the sea", "Water rises as vapour", "It cools into cloud", "Rain falls"],
    },
});
//# sourceMappingURL=sequence.js.map